import { COLORS } from '@btime/constants'
import { StepsHandler, useStepsState } from '@btime/react-contexts'
import { identity } from 'ramda'
import React, { Fragment } from 'react'

import { AbsolutePageTemplateWithoutControls } from '../../components/templates/AbsolutePageTemplate'
import Container from '../structure/Container'
import FlexGrid, { FlexCol } from '../structure/FlexGrid'
import HideOn from '../helpers/HideOn'
import MFooter from '../structure/M.Footer'
import Message from '../messenger/Message'
import Separator from '../helpers/Separator'
import SeparatorWrapper from '../helpers/SeparatorWrapper'
import StepButtons from './StepButtons'
import StepHeader from './StepHeader'
import StepsSideBar from './StepsSideBar'

const Steps = ({ t, raw }) => {
  const { error, currentStep } = useStepsState()
  const fullScreen = currentStep.fullScreen
  const fullWidth = currentStep.fullScreen
  const Wrapper = !fullScreen ? Fragment : AbsolutePageTemplateWithoutControls
  const ContentWrapper = !fullScreen ? Container : Fragment
  t = t || identity

  if (raw) return <currentStep.Component />

  return (
    <Wrapper>
      <FlexGrid align="stretch" minHeight="calc(100vh - 4.8rem)">
        {!fullWidth && (
          <FlexCol flex={1} hideOn="sm">
            <SeparatorWrapper weight={8}>
              <StepsSideBar t={t} />
            </SeparatorWrapper>
          </FlexCol>
        )}

        <FlexCol flex={4} bgColor={fullScreen ? COLORS.light1 : COLORS.white}>
          <SeparatorWrapper weight={fullScreen ? 0 : 8} weightOnSm={2}>
            <ContentWrapper>
              <Separator weight={6} hideOn="mdu" />
              <StepHeader t={t} />
              {!fullScreen && <Separator weight={4} />}
              <Message
                title={error}
                icon="BsExclamationTriangle"
                color={COLORS.dark3}
                bgColor={COLORS.red + '90'}
                noShadow
              />
              {!fullScreen && <Separator weight={4} />}
              <currentStep.Component />
            </ContentWrapper>

            <HideOn hideOn="mdu">
              <MFooter weight={34}>
                <StepButtons />
              </MFooter>
            </HideOn>
          </SeparatorWrapper>
        </FlexCol>
      </FlexGrid>
    </Wrapper>
  )
}

const Wrapper = ({ isEditing, steps, onSubmit, errorMessage, loading, forceStep, children, ...props }) => {
  return (
    <StepsHandler
      isEditing={isEditing}
      steps={steps}
      loading={loading}
      forceStep={forceStep}
      errorMessage={errorMessage}
      onSubmit={onSubmit}
    >
      {children}
      <Steps {...props} />
    </StepsHandler>
  )
}

export default Wrapper
